function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#202020",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.9 20v3.079c0 .41.3.821.8.821.4 0 .8-.308.8-.821v-1.54c-.7-.41-1.2-.923-1.6-1.539z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.7 11.8C11.6 4.6 8.1 0 7.1 0 5.9 0 2.5 4.6 2.3 11.7c-1.1 0-2 .7-2 1.8v5.8c0 1.1.8 1.6 1.8 1.1l.5-.3c.4-.2.7-.5 1-.9.1-.1.2-.3.3-.4v-.1c.1-.1.1-.2.2-.4v-.1c0-.1.1-.2.1-.4v-.1c0-.2.1-.3.1-.5.1.1.3.1.5.2.1 0 .2.1.3.1.3.1.7.2 1.1.2h1.5c.5 0 1-.1 1.4-.3.2-.1.3-.1.5-.2 0 .2 0 .3.1.5v.1c0 .1.1.2.1.3 0 0 0 .1.1.1.1.1.1.2.2.4 0 0 0 .1.1.1.3.5.7 1 1.2 1.2l.5.3c1 .5 1.8.1 1.8-1l.1-5.8c-.1-.8-1-1.6-2.1-1.6zM7 10.3c-1.1 0-2.1-.9-2.1-2.1 0-1.2.9-2.1 2.1-2.1 1.2 0 2.1.9 2.1 2.1 0 1.2-1 2.1-2.1 2.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 19.7h-.7v2.6c0 .4.3.8.8.8.4 0 .8-.3.8-.8v-2.6H7zM3.6 21.462v1.658c0 .39.3.78.8.78.4 0 .8-.292.8-.78V20c-.5.585-1 1.073-1.6 1.462z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24"
  }, props), _ref);
};

export default SvgComponent;